import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-clearance-review',
  templateUrl: './clearance-review.component.html',
  styleUrls: ['./clearance-review.component.scss']
})
export class ClearanceReviewComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() contactSupport = new EventEmitter<void>();
  @Output() nextModal = new EventEmitter<void>();

}